import {
  enumeratedLiterals,
  type EnumeratedLiteralType,
} from "./enumeratedLiterals";

export const CustomerTypes = enumeratedLiterals(
  ["first_time", "returning"] as const,
  {
    getLabels: (a) => ({
      [a.FIRST_TIME]: "First time",
      [a.RETURNING]: "Returning",
    }),
  },
);

export type CustomerType = EnumeratedLiteralType<typeof CustomerTypes>;
